

var isOnline = location.host.indexOf('chmemore.com') != -1;
var baseUrl = isOnline ? '//truefalse.api.vidamm.com/index.php?r=' : '//truefalse.api.vidamm.com/index.php?r=';
var baseHomeUrl = isOnline ? 'https://truefalse.api.vidamm.com' : 'https://truefalse.api.vidamm.com';

export default {
    apiHost: baseUrl,
    baseHomeUrl:baseHomeUrl
}



// WEBPACK FOOTER //
// ./src/config.js